import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IInitialStateSubjectCheck, ISubjectCheckPayload} from "../types";
import {GetSubjectTypes} from "./thunk";
import {ITranslation} from "../../../../types";


const initialState: IInitialStateSubjectCheck = {
    subjectCheckData: [],
    checkSelectedIDs: [],
    isLoadingSubjectCheck: false,
    isViewSubjectCheck: false,
    filteredCheckType: [],
    checkTypeRestore: []
};

const subjectCheckTypeSlice = createSlice({
    name: "subjectCheck",
    initialState,
    reducers: {
        setSubjectCheck: (state, action: PayloadAction<{ data: ISubjectCheckPayload[], defaultLanguage: string }>) => {
            const {data, defaultLanguage} = action.payload;

            state.subjectCheckData = data
            state.filteredCheckType = state.subjectCheckData.flatMap(
                (data) =>
                    data.translations
                        .filter((elem: ITranslation) => elem.slug === defaultLanguage && elem.name)
                        .map((elem: ITranslation) => ({
                            id: data.id,
                            name: elem.name as string,
                            abbreviation: elem.abbreviation ?? "",
                        }))
            );
        },

        deletedSubjectCheck: (state, action: PayloadAction<number>) => {
            state.subjectCheckData = state.subjectCheckData.filter(
                (elem) => elem.id !== action.payload
            );
        },
        updateSubjectCheck: (
            state,
            action: PayloadAction<ISubjectCheckPayload>
        ) => {
            const updateData = action.payload;

            state.subjectCheckData = state.subjectCheckData.map(
                (elem: ISubjectCheckPayload) => {
                    if (elem.id === updateData.id) {
                        return {
                            ...elem,
                            ...updateData,
                        };
                    }
                    return elem;
                }
            );
        },


        setIsViewSubjectCheckRestore: (state) => {

            state.isViewSubjectCheck = !state.isViewSubjectCheck;
        },
        setSubjectCheckRestoreData: (state, action) => {
            state.checkTypeRestore = action.payload;
        },
        deletedRestoreSubjectCheck: (state, action) => {
            state.checkTypeRestore = state.checkTypeRestore.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedCheckIDs: (state, action) => {
            state.checkSelectedIDs=action.payload
        },

    },
    extraReducers(builder) {
        builder
            .addCase(GetSubjectTypes.pending, (state) => {
                state.isLoadingSubjectCheck = true;
            })
            .addCase(GetSubjectTypes.fulfilled, (state) => {
                state.isLoadingSubjectCheck = false;
            })
            .addCase(GetSubjectTypes.rejected, (state) => {
                state.isLoadingSubjectCheck = false;
            });
    },
});

export const {
    setSubjectCheck,
    deletedSubjectCheck,
    updateSubjectCheck,
    setIsViewSubjectCheckRestore,
    setSubjectCheckRestoreData,
    deletedRestoreSubjectCheck,
    setSelectedCheckIDs,

} = subjectCheckTypeSlice.actions

export default subjectCheckTypeSlice;
